var map = {
	"./android/DeviceSetup": 1747,
	"./hisense/DeviceSetup": 1748,
	"./lg/DeviceSetup": 1749,
	"./nagra/DeviceSetup": 1751,
	"./netrange/DeviceSetup": 1752,
	"./opera/DeviceSetup": 1753,
	"./ps4/DeviceSetup": 1754,
	"./samsung/DeviceSetup": 1755,
	"./seirobotics/DeviceSetup": 1756,
	"./sony/DeviceSetup": 1757,
	"./stbcoship/DeviceSetup": 1758,
	"./tizen/DeviceSetup": 1759,
	"./web0s/DeviceSetup": 1760,
	"./workstation/DeviceSetup": 1762,
	"./zeasn/DeviceSetup": 1763
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1746;


//////////////////
// WEBPACK FOOTER
// ./src/devices ^\.\/.*\/DeviceSetup$
// module id = 1746
// module chunks = 0